<mat-toolbar>
  <span>
    <h3>New Update Notice</h3>
  </span>
</mat-toolbar>
<mat-card class="mat-elevation-z0">
  <mat-card-content [formGroup]="form">
    <div class="form-container">
      <!-- Temporality -->
      <div class="row">
        <div class="left-content">Temporality</div>
        <div class="right-content">
          <mat-radio-group
            name="temporality"
            formControlName="temporality">
            <mat-radio-button
              class="example-radio-button"
              value="PERMANENT">
              Permanent
            </mat-radio-button>
            <mat-radio-button value="TEMPORARY">Temporary</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>

      <!-- Effective Date -->
      <div class="row">
        <div class="left-content">Effective Date</div>
        <div class="right-content">
          <div class="row">
            <mat-form-field class="effective-date-field">
              <mat-label>Effective Date</mat-label>
              <app-custom-datepicker-tz
                #effDatePicker
                required
                formControlName="effectiveDate"
                label="Effective Date"
                [minDate]="validEffDate"
                [dateClass]="dateClass"
                [timezone]="fc.timezone.value"
                (dateChange)="getDueDate(fc.effectiveDate)">
              </app-custom-datepicker-tz>
              <button
                mat-icon-button
                matSuffix
                type="button"
                (click)="effDatePicker.openOverlay()">
                <mat-icon>today</mat-icon>
              </button>
              <mat-error>Effective date is required</mat-error>
            </mat-form-field>
            <!-- Time field -->
            <mat-form-field class="time-field">
              <mat-label>Time</mat-label>
              <input
                readonly
                matInput
                type="text"
                [value]="fc.effectiveDate?.value | dateTz: 'HH:mm': fc.timezone.value" />
            </mat-form-field>
            <!-- Timezone field -->
            <mat-form-field class="timezone-field">
              <mat-label>Select a Timezone</mat-label>
              <app-timezone-select formControlName="timezone"></app-timezone-select>
              <mat-error>Timezone is required</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Due Date -->
      <div class="row">
        <div class="left-content">Due Date</div>
        <div class="right-content">
          <mat-form-field>
            <input
              placeholder="Due Date"
              readonly
              type="text"
              matInput
              [value]="dueDate || ''" />
          </mat-form-field>
        </div>
      </div>

      <!-- Cancel Date -->
      <div
        class="row"
        *ngIf="form.controls['temporality'].value == 'TEMPORARY'">
        <div class="left-content">Cancel Date</div>
        <div class="right-content">
          <div class="row">
            <mat-form-field class="cancel-date-field">
              <mat-label>Cancel Date</mat-label>
              <app-custom-datepicker-tz
                #cancelDatePicker
                [minDate]="validCancelDate"
                formControlName="cancelDate"
                label="Cancel Date"
                [dateClass]="dateClass"
                [timezone]="fc.timezone.value">
              </app-custom-datepicker-tz>
              <button
                mat-icon-button
                matSuffix
                type="button"
                (click)="cancelDatePicker.openOverlay()">
                <mat-icon>today</mat-icon>
              </button>
              <mat-error *ngIf="!!fc.cancelDate.errors?.required"> Cancel date is required </mat-error>
              <mat-error *ngIf="!!fc.cancelDate.errors?.CheckDate">
                Cancel date must not be less or equal to effective date
              </mat-error>
            </mat-form-field>
            <!-- Time field -->
            <mat-form-field class="time-field">
              <mat-label>Time</mat-label>
              <input
                readonly
                matInput
                type="text"
                [value]="fc.cancelDate?.value | dateTz: 'HH:mm': fc.timezone.value" />
            </mat-form-field>
            <div style="top: -10px; position: relative">{{fc.timezone.value}}</div>
          </div>
        </div>
      </div>

      <!-- Title -->
      <div class="row">
        <div class="left-content">Title</div>
        <div class="right-content">
          <mat-form-field class="title-field">
            <mat-label>Title</mat-label>
            <input
              matInput
              formControlName="name"
              placeholder="Enter title" />
            <mat-error *ngIf="form.controls.name.hasError('required')"> Title is required </mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Description -->
      <div class="row">
        <div class="left-content">Description</div>
        <div class="right-content">
          <mat-form-field class="description-field">
            <textarea
              matInput
              formControlName="description"
              placeholder="Enter description"
              rows="2"></textarea>
          </mat-form-field>
        </div>
      </div>

      <!-- Attachment -->
      <div class="row">
        <div class="left-content">Attachments</div>
        <div class="right-content">
          <input
            type="file"
            matTooltip="Add Attachment"
            hidden
            ng2FileSelect
            #file
            [uploader]="uploader"
            multiple />
          <button
            type="button"
            class="material-icons"
            (click)="file.click()">
            &#xE226;
          </button>
          <div class="attachment-list">
            <ng-container *ngFor="let item of uploader.queue">
              <div class="attachment">
                <span class="file-name"> {{ item?.file?.name }} </span>
                <button
                  mat-icon-button
                  (click)="remove(item)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions class="card-actions">
    <button
      mat-raised-button
      color="primary"
      [disabled]="form.invalid"
      (click)="addUpdateNotice(form.value)">
      Submit
    </button>
    <button
      mat-raised-button
      color="warn"
      (click)="cancel()">
      Cancel
    </button>
  </mat-card-actions>
</mat-card>
